export const environment = {
  production: false,
  uploadBaseUrl: 'https://www.chatbot.hk/'
};

